import { render, staticRenderFns } from "./TestGeo.vue?vue&type=template&id=3c69fada&scoped=true"
import script from "./TestGeo.vue?vue&type=script&lang=js"
export * from "./TestGeo.vue?vue&type=script&lang=js"
import style0 from "./TestGeo.vue?vue&type=style&index=0&id=3c69fada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c69fada",
  null
  
)

export default component.exports